import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../api/commAxios'
import {setToken} from '@/utils/auth';
import {getJcCcxs, getJcZjxx, getJcXwxx,getXxCcxs,getXxZjxx,getXxXwxx,getXxDbxx} from '../api/guarantee'
import {typeXwbqsx} from "@/filters";  // 导入接口

Vue.use(Vuex);
Vue.prototype.$axios = axios

function formatData(data) {
    return data.filter(item => (item.valid === 1))
        .map(item => ({text: item.name, keyId: item.code}))
}

/**
 * 列表list转化成map对象
 * @param {Array<Object>} data 数据列表
 * @returns {Object}
 * */
function listToMap(data) {
    const map = {};
    data.forEach(itemData => {
        map[itemData.code] = {
            // 对应的key值
            keyId: itemData.code,
            // 对应的文本
            text: itemData.name
        }
    });
    return map;
}

const store = new Vuex.Store({
    state: {
        // 为嵌入在线服务小程序新增——浏览器标题栏文字
        browserHeaderTitle: '在线保全',
        logoutUrl: '',
        // 代码map值
        codeMap: {},
        // 代理人类型
        codeType_103000: [],
        // 证件类型
        codeType_105000: [],
        // 工作单位性质
        codeType_108000: [],
        // 证件(照)类型-证照
        codeType_109000: [],
        // 性别
        codeType_110000: [],
        // 财产类型
        codeType_112000: [],
        // 行为保全事项
        codeType_301250: [],
        // 提交人身份
        codeType_118000: [],
        // 币种
        codeType_119000: [],
        // 民族
        codeType_120000: [],
        // 案件类型
        codeType_121000: [],
        // 单位
        codeType_131000: [],
        // 车辆类型
        codeType_132000: [],
        // 保全类型
        codeType_301000: [],
        // 非诉财产
        codeType_301110: [],
        // 非诉财产2
        codeType_301160: [],
        // 非诉行为
        codeType_301210: [],
        // 非诉证据
        codeType_301510: [],
        // 保全类别
        codeType_304000: [],
        // 无需担保原因
        codeType_601000: [],
        // 诉讼地位
        codeType_702000: [],
        // 复议事项
        codeType_706000: [],
        // 解除事由
        codeType_804000: [],
        // 省份
        codeType_805000: [],
        // 案件类型
        codeType_807000: [],
        codeType_901000: [],
        //续行保全事由
        codeType_823000: [],
        // 担保申请的担保状态代码表
        codeType_206000: [],
        // 解除保全财产线索
        JCBQCCXS: [],
        // 解除保全证据信息
        JCBQZJXX: [],
        // 解除保全行为信息
        JCBQXWXX: [],
        JCBQJBXX: [],
        // 续行保全财产线索
        XXBQCCXS: [],
        // 续行保全证据信息
        XXBQZJXX: [],
        // 续行保全行为信息
        XXBQXWXX: [],
        XXBQJBXX: [],
        // 续行保全担保信息
        XXBQDBXX: [],
    },
    getters: {
        // 为嵌入在线服务小程序新增——浏览器标题栏文字
        browserHeaderTitle(state) {
            return state.browserHeaderTitle
        },
        // 解除保全财产线索
        jcbqccxsData(state) {
            return state.JCBQCCXS
        },
        // 解除保全证据信息
        jcbqzjxxData(state) {
            return state.JCBQZJXX
        },
        // 解除保全行为信息
        jcbqxwxxData(state) {
            return state.JCBQXWXX
        },
        // 解除保全财产线索
        xxbqccxsData(state) {
            return state.XXBQCCXS
        },
        // 解除保全证据信息
        xxbqzjxxData(state) {
            return state.XXBQZJXX
        },
        // 解除保全行为信息
        xxbqxwxxData(state) {
            return state.XXBQXWXX
        },
        // 续行保全担保信息
        xxbqdbxxData(state) {
            return state.XXBQDBXX
        },
        /**
         * 获取code对应的map数据
         * @params {Object} state
         * returns {Function} 函数是为了可以传参
         * */
        codeGetMap(state) {
            return (code) => {
                return state.codeMap[code];
            };
        },
        codeList_103000(state) {
            return formatData(state.codeType_103000)
        },
        codeList_105000(state) {
            return formatData(state.codeType_105000)
        },
        codeList_108000(state) {
            return formatData(state.codeType_108000)
        },
        codeList_109000(state) {
            return formatData(state.codeType_109000)
        },
        codeList_110000(state) {
            return formatData(state.codeType_110000)
        },
        codeList_112000(state) {
            return formatData(state.codeType_112000)
        },
        codeList_301250(state) {
            return formatData(state.codeType_301250)
        },
        codeList_118000(state) {
            return formatData(state.codeType_118000)
        },
        codeList_119000(state) {
            return formatData(state.codeType_119000)
        },
        codeList_120000(state) {
            return formatData(state.codeType_120000)
        },
        codeList_121000(state) {
            return formatData(state.codeType_121000)
        },
        codeList_131000(state) {
            return formatData(state.codeType_131000)
        },
        codeList_132000(state) {
            return formatData(state.codeType_132000)
        },
        codeList_301110(state) {
            return formatData(state.codeType_301110)
        },
        codeList_301160(state) {
            return formatData(state.codeType_301160)
        },
        codeList_301210(state) {
            return formatData(state.codeType_301210)
        },
        codeList_301510(state) {
            return formatData(state.codeType_301510)
        },
        codeList_301000(state) {
            return formatData(state.codeType_301000)
        },
        codeList_304000(state) {
            return formatData(state.codeType_304000)
        },
        codeList_601000(state) {
            return formatData(state.codeType_601000)
        },
        codeList_702000(state) {
            return formatData(state.codeType_702000)
        },
        codeList_706000(state) {
            return formatData(state.codeType_706000)
        },
        codeList_804000(state) {
            return formatData(state.codeType_804000)
        },
        codeList_805000(state) {
            return formatData(state.codeType_805000)
        },
        codeList_807000(state) {
            return formatData(state.codeType_807000)
        },
        codeList_901000(state) {
            return formatData(state.codeType_901000)
        },
        codeList_823000(state) {
            return formatData(state.codeType_823000)
        },
    },
    mutations: {
        /**
         * 为嵌入在线服务小程序新增——设置浏览器标题（嵌入在线服务小程序，要去掉带返回的标题栏，浏览器标题会显示在在线服务小程序带返回的webview顶部）
         * */
        SET_BROWSERHEADERTITLE(state, action) {
            state.browserHeaderTitle = action.browserHeaderTitlel;
        },
        /**
         * 设置登录退出的url地址
         * */
        SET_LOGOUTURL(state, url) {
            state.logoutUrl = url;
        },
        /**
         * 设置code map
         * */
        SET_CODE_MAP(state, _data) {
            // 冻结住，减少性能消耗
            state.codeMap[_data.code] = Object.freeze(listToMap(_data.data));
        },
        SET_CODETYPE: (state, _data) => {
            // 冻结住，减少性能消耗
            state[`codeType_${ _data.code}`] = Object.freeze(_data.data);
        },
        // 解除保全财产线索
        SET_JCBQCCXS: (state,data) => {
            state.JCBQCCXS = data
        },
        // 解除保全证据信息
        SET_JCBQZJXX: (state,data) => {
            state.JCBQZJXX = data
        },
        // 解除保全行为信息
        SET_JCBQXWXX: (state,data) => {
            state.JCBQXWXX = data
        },
        SET_JCBQJBXX: (state, data) => {
            state.JCBQJBXX = data
        },
        // 续行保全财产线索
        SET_XXBQCCXS: (state,data) => {
            state.XXBQCCXS = data
        },
        // 续行保全证据信息
        SET_XXBQZJXX: (state,data) => {
            state.XXBQZJXX = data
        },
        // 续行保全行为信息
        SET_XXBQXWXX: (state,data) => {
            state.XXBQXWXX = data
        },
        // 续行保全基本信息
        SET_XXBQJBXX: (state, data) => {
            state.XXBQJBXX = data
        },
        // 续行保全基本信息
        SET_XXBQDBXX: (state, data) => {
            state.XXBQDBXX = data
        },
    },
    actions: {
        // 保存解除保全基本信息数据
        SetJCBQJBXX({commit}, data) {
            commit('SET_JCBQJBXX', data)
        },
        logout({ commit }) {
            axios.post("/account/api/account/logout")
                .then(() => {
                    console.log("合适的话施工规范化的规范化的=====", process.env.VUE_APP_ALI_BASE_URL_PRO)
                    // this.logoutUrl = process.env.VUE_APP_ALI_BASE_URL_PRO + "/oauth/logout";
                    // 设置退出登录的地址
                    commit('SET_LOGOUTURL', process.env.VUE_APP_ALI_BASE_URL_PRO + "/oauth/logout");
                });
            window.addEventListener('message', (e) => {
                let res = {
                    message: ''
                };
                try {
                    res = JSON.parse(e.data)
                } catch (e) {
                    console.log(e);
                }
                //消息类型
                if (res.message == '登出成功') {
                    // 清除失效token
                    setToken(null);
                    // 清除缓存
                    localStorage.clear()
                    // 回到阿里登录页
                    this.$router.push("/ali_login");
                    this.$notify({
                        type: "success",
                        message: '登出成功'
                    });
                }
            })
        },
        // 获取单值代码
        GetCodeType({commit, state}, code) {
            return new Promise((resolve, reject) => {
                // 如果已经存在，则不需要进行请求
                if(state[`codeType_${code}`] && state[`codeType_${code}`].length > 0){
                    resolve();
                    return;
                }
                axios.get('ssbq/api/code?codetype=' + code)
                    .then((response) => {
                        commit('SET_CODETYPE', {
                            code,
                            data: response.data,
                        });
                        // 存储到codeMap中
                        commit('SET_CODE_MAP', {
                            code,
                            data: response.data
                        });
                        resolve();
                    })
                        .catch(e => {
                            reject(e);
                        })
            });
        },
        // 获取解除保全行为信息索列表
        GetJCBQXWXXList({commit}, params) {
            return new Promise((resolve, reject) => {
                getJcXwxx(params).then(response => {
                    let {data} = response
                    commit('SET_JCBQXWXX', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取解除保全财产线索索列表
        GetJCBQCCXSList({commit}, params) {
            return new Promise((resolve, reject) => {
                getJcCcxs(params).then(response => {
                    let {data} = response
                    commit('SET_JCBQCCXS', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取解除保全证据信息索列表
        GetJCBQZJXXList({commit}, params) {
            return new Promise((resolve, reject) => {
                getJcZjxx(params).then(response => {
                    let {data} = response
                    commit('SET_JCBQZJXX', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取续行保全财产线索列表
        GetXXBQCCXSList({commit}, params) {
            return new Promise((resolve, reject) => {
                getXxCcxs(params).then(response => {
                    let {data} = response
                    commit('SET_XXBQCCXS', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取续行保全证据信息列表
        GetXXBQZJXXList({commit}, params) {
            return new Promise((resolve, reject) => {
                getXxZjxx(params).then(response => {
                    // debugger
                    let {data} = response
                    commit('SET_XXBQZJXX', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取续行保全行为信息列表
        GetXXBQXWXXList({commit}, params) {
            return new Promise((resolve, reject) => {
                getXxXwxx(params).then(response => {
                    let {data} = response
                    commit('SET_XXBQXWXX', data)
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
        // 获取续行保全担保信息列表
        GetXXBQDBXXList({commit}, params) {
            return new Promise((resolve, reject) => {
                getXxDbxx(params).then(response => {
                    let {data} = response
                    commit('SET_XXBQDBXX', data)
                    // commit('SET_XXBQOLDDBXXLIST', data)
                    // commit('CLEAR_BQ_IDS', 'dbxsIds')
                    resolve(response)
                }).catch(error => {
                    console.log(error);
                    reject(error)
                })
            })
        },
    }
})

export default store
